import React from 'react'
import Loader from 'monday-ui-react-core/dist/Loader'
export default function MondayLoader({text = ''}) {
  return (
    <div className="loader-container flex column">
      <Loader
        color={Loader.colors.PRIMARY}
        size={Loader.sizes.MEDIUM}
      />
      <p style={{ display: 'block' }}>
        {text}
      </p>
    </div>
  )
}
